import { ClubCreateFormWidget } from '@features/club/ui/ClubCreateForm/ClubCreateFormWidget';
import { ClubCreateModal } from '@features/club/ui/ClubCreateModal/ClubCreateModal';
import { ClubCreateFormWidgetProps } from '@features/club/ui/ClubCreateForm';

type Props = {
  onClose: () => void;
} & ClubCreateFormWidgetProps;

export function ClubCreateModalWidget({ onClose, ...formProps }: Props) {
  return (
    <ClubCreateModal onClose={onClose}>
      <ClubCreateFormWidget {...formProps} />
    </ClubCreateModal>
  );
}
